import React from 'react';
import {Map, List} from 'immutable';
import {iconName, qualify} from '@packages/systems/wfdl-Qualified';
import {Atom, Plugins} from '@packages/systems/wfdl';
import {checkoutInputStyle, mobileCheckoutInputStyle} from './styles';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';

const CityInput = Atom.createRender(
  ({attributes, classes, generateAttributes}) => {
    return (
      <input
        {...generateAttributes(attributes, classes)}
        name="address_city"
        type="text"
        required
      />
    );
  }
);

const staticBindings = Map({
  value: List([
    Map({
      slug: 'shippingAddressCity',
      type: 'PlainText',
    }),
  ]),
});

const config = createIntegratedAtom({
  displayName: 'City',
  icon: {
    type: 'Component',
    value: qualify(Plugins.name('Form'), iconName('Input')),
  },
  showEmpty: false,
  render: CityInput,
  style: {
    base: {
      main: checkoutInputStyle,
      tiny: mobileCheckoutInputStyle,
    },
  },
  staticBindings,
  fields: {},
});

export default config;
